/**
 * Enum representing the possible status values for a locate order. WIP
 */
export var LocateOrderStatus;
(function (LocateOrderStatus) {
    /** The order has been optimistically generated and sent to the backend. */
    LocateOrderStatus["sent"] = "sent";
    /** The order is pending and has not yet been processed. */
    LocateOrderStatus["pending"] = "pending";
    /** The order is pending and will continue to be processed until cancelled. */
    LocateOrderStatus["pendingContinuous"] = "pendingContinuous";
    /** The order has failed and cannot be fulfilled. */
    LocateOrderStatus["failed"] = "failed";
    /** The order has been cancelled by the requester. */
    LocateOrderStatus["cancelled"] = "cancelled";
    /** The order has been created and is awaiting processing. */
    LocateOrderStatus["created"] = "created";
    /** The order has been provided to the requester. */
    LocateOrderStatus["provided"] = "provided";
    /** The order has been quoted, and will not become provided */
    LocateOrderStatus["quoted"] = "quoted";
    /** The order has been accepted by the provider. */
    LocateOrderStatus["accepted"] = "accepted";
    /** The order has been rejected by the provider. */
    LocateOrderStatus["rejected"] = "rejected";
})(LocateOrderStatus || (LocateOrderStatus = {}));
//# sourceMappingURL=orders.js.map